module.exports = __webpack_public_path__ + "static/media/quiz.9b72e1f4.gif";